import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { TipoTela } from "./types";

interface CriarTelaModalProps {
    show: boolean;
    onHide: () => void;
    onSubmit: (e: React.FormEvent) => void;
    tipoTela: TipoTela;
    setTipoTela: (tipo: TipoTela) => void;
    quantidade: string;
    setQuantidade: (qtd: string) => void;
}

export const CriarTelaModal: React.FC<CriarTelaModalProps> = React.memo(
    ({
        show,
        onHide,
        onSubmit,
        tipoTela,
        setTipoTela,
        quantidade,
        setQuantidade,
    }) => (
        <Modal show={show} onHide={onHide} centered className="_telascustom-modal">
            <Modal.Header closeButton className="_telasmodal-header-custom">
                <Modal.Title className="_telasmodal-title-custom">Criar Tela</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit} className="_telasformulario-modal">
                    <Form.Group controlId="formTipoTela" className="_telasform-group-custom">
                        <Form.Label className="_telasform-label-custom">Tipo de Tela:</Form.Label>
                        <div className="_telasradio-group-container">
                            {["ACIDO", "KOMATSU", "OPAL / ACIDO / ESPECIAL", "INTERNO NEGRO", "LECTURA INTERIOR"].map((tipo) => (
                                <Form.Check
                                    key={tipo}
                                    type="radio"
                                    id={`radio-${tipo.toLowerCase()}`}
                                    label={tipo}
                                    name="tipoTela"
                                    value={tipo}
                                    checked={tipoTela === tipo}
                                    onChange={(e) => setTipoTela(e.target.value as TipoTela)}
                                    className="_telascustom-radio"
                                />
                            ))}
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="_telasmodal-footer-custom">
                <Button
                    variant="outline-secondary"
                    onClick={onHide}
                    className="btn-cancel"
                >
                    Fechar
                </Button>
                <Button
                    variant="primary"
                    onClick={onSubmit}
                    className="btn-save"
                    disabled={!tipoTela}
                >
                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    )
);
